import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"

import {
  getAccountAccountTypeList,
  getAccountAccountTypeById,
  createAccountAccountType,
  updateAccountAccountType,
  deleteAccountAccountType,
} from "api/accountAccountTypeApi"

export const ACCOUNT_ACCOUNT_TYPE_QUERY_KEY = "account-account-type"

export const useAccountAccountTypes = (params = {}, enabled = true) => {
  return usePaginatedResource(
    ACCOUNT_ACCOUNT_TYPE_QUERY_KEY,
    getAccountAccountTypeList,
    params,
    enabled
  )
}

export const useAccountAccountType = (id, enabled = true) => {
  return useResourceItem(
    ACCOUNT_ACCOUNT_TYPE_QUERY_KEY,
    getAccountAccountTypeById,
    id,
    enabled
  )
}

export const useCreateAccountAccountType = () => {
  return useCreateResource(
    createAccountAccountType,
    ACCOUNT_ACCOUNT_TYPE_QUERY_KEY
  )
}

export const useEditAccountAccountType = () => {
  return useEditResource(
    updateAccountAccountType,
    ACCOUNT_ACCOUNT_TYPE_QUERY_KEY
  )
}

export const useDeleteAccountAccountType = () => {
  return useDeleteResource(
    deleteAccountAccountType,
    ACCOUNT_ACCOUNT_TYPE_QUERY_KEY
  )
}
